// extracted by mini-css-extract-plugin
var _1 = "IntegrationsPreviewModal-modulebox__lfwPi";
export { _1 as "box" }
